import type { ReactNode } from 'react';

import { BevelWindow } from '@/components/prototype/bevel-window';

/*
 * The centered bevel card shell shared by every auth screen (login, register,
 * password flows, verify-email). Keeps the prototype chrome consistent.
 */
interface AuthCardProps {
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function AuthCard({ title, children, footer }: AuthCardProps) {
  return (
    <div className="mx-auto max-w-md px-4 py-10">
      <BevelWindow title={title} shadow="lg" bodyClassName="p-5">
        {children}
      </BevelWindow>
      {footer ? <div className="mt-4 text-center font-mono text-xs text-dim">{footer}</div> : null}
    </div>
  );
}
